
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import Table from "@/components/Table.vue";

export default Vue.extend({
  name: "Hauptwerte",
  components: {
    Loader,
    Table
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      stammdatenView: {
        name: "messstellen_grundwasser_stammdaten",
        condition: "messstellennummer=number:" + this.id
      },
      periodView: {
        // 	gesamtzeitraum = loadGesamtzeitraum(msn);
        name: "messstellen_grundwasser_hauptwerte_gesamtzeitraum",
        condition: "messst_nr=number:" + this.id
      },
      lastMonthValuesView: {
        //  datMonatsmittel_letztes = hw.loadLastMonatsmittel(msn)
        name: "messstellen_grundwasser_hauptwerte_lastmonatsmittel",
        condition: "messst_nr=number:" + this.id
      },
      monthlyValuesView: {
        // gesamtzeitMesspunkte = hw.loadMonatsmittel(msn)
        name: "messstellen_grundwasser_hauptwerte_monatsmittel",
        condition: "messst_nr=number:" + this.id
      },
      totalValuesView: {
        // datMaximum_gesamtzeit = hw.loadMaximalWerte(msn)
        name: "messstellen_grundwasser_hauptwerte_maximalwerte",
        condition: "messst_nr=number:" + this.id
      },
      stammdaten: [] as any[],
      startYear: 0,
      endYear: 0,
      selectedYear: 0,
      monthlyTableValues: [] as any[],
      totalTableValues: [] as any[],
      monthlyTableHeader: [] as any[],
      totalTableHeader: [] as any[]
    };
  },
  computed: {
    monthlyValuesByYearView: function(): any {
      return {
        // einzelzeitMesspunkte = hw.loadMonatsmittel(msn,year);
        name: "messstellen_grundwasser_hauptwerte_monatsmittel",
        condition: [
          "messst_nr=number:" + this.id,
          "year=number:" + this.selectedYear
        ]
      };
    },
    totalValuesByYearView: function(): any {
      return {
        // einzelzeitMesspunkte = hw.loadMonatsmittel(msn,year);
        name: "messstellen_grundwasser_hauptwerte_maximalwerte",
        condition: [
          "messst_nr=number:" + this.id,
          "year=number:" + this.selectedYear
        ]
      };
    },
    messstellenArt: function(): any | null {
      return (this as any).stammdaten &&
        (this as any).stammdaten.MESSSTELLENART === "Quellen"
        ? "Quellschüttung (l/s)"
        : "Wasserstand (NN+m)";
    },
    messstellenArtMult: function(): any {
      return (
        ((this as any).stammdaten &&
        (this as any).stammdaten.MESSSTELLENART === "Quellen"
          ? "Quellschüttungen (l/s) "
          : "Wasserstände (NN+m) ") +
        this.startYear +
        " - " +
        this.endYear
      );
    }
  },
  methods: {
    rangeReverse(start: number, end: number) {
      const length = end + 1 - start;
      return Array.from({ length }, (_, i) => start + i)
        .slice()
        .reverse();
    },
    loadedStammData(data: any[]) {
      // data order : [stammdatenView, periodView]
      this.stammdaten = data[0][0];
      const gesamtzeitraum = data[1][0];

      // TODO: BUG gesamtzeitraum kann [] sein;
      if (gesamtzeitraum) {
        // Jahresliste generieren
        const startDate = new Date(
          gesamtzeitraum.BEGINN.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3")
        );
        // evtl. korrigieren, da hydrologisches Jahr von 11.(Jahr-1) - 10.Jahr geht

        this.startYear =
          startDate.getMonth() + 1 > 10
            ? startDate.getFullYear() + 1
            : startDate.getFullYear();

        const endDate = new Date(
          gesamtzeitraum.ENDE.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3")
        );
        // evtl. korrigieren, da hydrologisches Jahr von 11.(Jahr-1) - 10.Jahr geht
        this.endYear =
          endDate.getMonth() + 1 > 10
            ? endDate.getFullYear() + 1
            : endDate.getFullYear();

        this.selectedYear = this.endYear;
      }
    },
    loadedMonthlyTableData(data: any[]) {
      // reset data
      this.monthlyTableValues = [];
      // data order : [monthlyValuesByYearView, monthlyValuesView ]
      const monthlyValuesByYear = data[0];
      const monthlyValues = data[1];
      const monthNames = [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ];
      // merge arrays by key MONAT
      const valueArray = monthNames.map((monthName: string, index: number) => {
        index++;
        const month = index < 10 ? "0" + index : index;
        // find month from selected year
        const yearObject = monthlyValuesByYear.filter(
          (value: any) => value.MONAT == month
        )[0];
        // find month from average
        const averageObject = monthlyValues.filter(
          (value: any) => value.MONAT == month
        )[0];
        // create table object
        return {
          month: month,
          name: monthName,
          yearValue: yearObject?.MITTELWERTZEIT || 0,
          yearMeasurements: yearObject?.ANZAHL || 0,
          averageValue: averageObject?.MITTELWERTZEIT || 0,
          averageMeasurements: averageObject?.ANZAHL || 0
        };
      });

      // Einschräkung der Query auf hydrologisches Jahr
      // Hydrologisches Jahr: 11.(Jahr-1) bis 10.Jahr
      // shift array of 2 elements to the left to start with november
      const values = valueArray.concat(
        valueArray.splice(0, valueArray.length - 2)
      );

      // calculate additional values 1. Halbjahr, 2. Halbjahr, Jahr
      const yearCalculation = (
        beginn: number,
        end: number,
        mergeObject: any
      ) => {
        // a array reduce function, which combines all elements to one
        const combineFunction = (pre: any, cur: any) => {
          const add = (pre: any, cur: any) =>
            (isNaN(pre) ? 0 : pre) + (isNaN(cur) ? 0 : cur);
          const preCopy = Object.assign({}, pre);
          preCopy.yearValue = add(pre.yearValue, cur.yearValue);
          preCopy.yearMeasurements = add(
            pre.yearMeasurements,
            cur.yearMeasurements
          );
          preCopy.averageValue = add(pre.averageValue, cur.averageValue);
          preCopy.averageMeasurements = add(
            pre.averageMeasurements,
            cur.averageMeasurements
          );
          return preCopy;
        };
        // a function with divides the values by the amount of values to get the average
        const divideValues = (obj: any, beginn: number, end: number) => {
          const countValues = (key: string) =>
            values.slice(beginn, end).filter((item: any) => item[key] != 0)
              .length;

          obj.yearValue = obj.yearValue / countValues("yearValue") || 0;
          obj.averageValue =
            obj.averageValue / countValues("averageValue") || 0;
          return obj;
        };

        return Object.assign(
          divideValues(
            values.slice(beginn, end).reduce(combineFunction),
            beginn,
            end
          ),
          mergeObject
        );
      };

      const firstHalf = yearCalculation(0, 6, {
        name: "1. Halbjahr",
        month: "1-6"
      });
      const secondHalf = yearCalculation(6, 12, {
        name: "2. Halbjahr",
        month: "7-12"
      });
      const year = yearCalculation(0, 12, { name: "Jahr", month: "1-12" });

      // add values additional values to table array
      this.monthlyTableValues = values.concat([firstHalf, secondHalf, year]);

      // round values
      this.monthlyTableValues.forEach(obj => {
        if (obj.yearValue > 0)
          obj.yearValue = obj.yearValue.toFixed(2).replace(".", ",");
        if (obj.averageValue > 0)
          obj.averageValue = obj.averageValue.toFixed(2).replace(".", ",");
      });

      this.monthlyTableHeader = [
        {
          text: "",
          key: "name"
        },
        {
          text: this.messstellenArt,
          key: "yearValue"
        },
        {
          text: "Messungen",
          key: "yearMeasurements"
        },
        {
          text: this.messstellenArtMult,
          key: "averageValue"
        },
        {
          text: "Messungen " + this.startYear + " - " + this.endYear,
          key: "averageMeasurements"
        }
      ];
    },

    loadedTotalTableData(data: any[]) {
      // reset data
      this.totalTableValues = [];
      // data order : [totalValuesByYearView, totalValuesView ]
      const totalValuesByYear = data[0][0];
      const totalValues = data[1][0];

      let maximumYear = "";
      let maximumDateYear = "";
      let minimumYear = "";
      let minimumDateYear = "";
      if (totalValuesByYear !== undefined) {
        maximumYear = totalValuesByYear.MAXIMUM;
        maximumDateYear = totalValuesByYear.MAXIMUMDAT;
        minimumYear = totalValuesByYear.MINIMUM;
        minimumDateYear = totalValuesByYear.MINIMUMDAT;
      }
      this.totalTableValues = [
        {
          name: "Maximum",
          yearValue: maximumYear,
          yearDate: maximumDateYear,
          averageValue: totalValues.MAXIMUM,
          averageDate: totalValues.MAXIMUMDAT
        },
        {
          name: "Minimum",
          yearValue: minimumYear,
          yearDate: minimumDateYear,
          averageValue: totalValues.MINIMUM,
          averageDate: totalValues.MINIMUMDAT
        }
      ];

      this.totalTableHeader = [
        {
          text: "",
          key: "name"
        },
        {
          text: this.messstellenArt,
          key: "yearValue"
        },
        {
          text: "Datum der Messung",
          key: "yearDate"
        },
        {
          text: this.messstellenArtMult,
          key: "averageValue"
        },
        {
          text: "Datum der Messungen",
          key: "averageDate"
        }
      ];
    }
  }
});
